
(function() {
  var drawer = document.getElementById('mini-cart');
  if (!drawer) return;
  var THRESHOLD = parseInt(drawer.dataset.freeShipThreshold, 10) || 5000;
  var RESERVATION_MINUTES = parseInt(drawer.dataset.reservationMinutes, 10) || 15;

  // --- v15.1 — i18n : préfixe de langue/marché (ex: /it-it, /en-gb) pour tous les appels AJAX ---
  // routes.root_url vaut "/" en locale par défaut et "/it-it" (sans slash final) en italien.
  // Sans ce préfixe, /?sections=... et /cart/*.js se rendent dans la locale par défaut (FR),
  // ce qui écrase les traductions Translate & Adapt des titres produits/variantes.
  var ROOT = drawer.dataset.rootUrl || '/';
  var BASE = (ROOT === '/' || !ROOT) ? '' : ROOT.replace(/\/$/, '');

  var isOpen = false;
  var refreshLock = false;

  function open() {
    if (isOpen) return;
    isOpen = true;
    drawer.classList.add('is-open');
    // trava a página por trás em todos os navegadores (iOS ignora overflow só no body)
    document.documentElement.style.setProperty('overflow', 'hidden', 'important');
    document.body.style.setProperty('overflow', 'hidden', 'important');
  }
  function close() {
    if (!isOpen) return;
    isOpen = false;
    drawer.classList.remove('is-open');
    document.documentElement.style.removeProperty('overflow');
    document.body.style.removeProperty('overflow');
  }

  drawer.addEventListener('click', function(e) {
    if (e.target.closest('[data-cd-close]')) { e.preventDefault(); e.stopPropagation(); close(); }
  }, true);
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape' && isOpen) close(); });

  document.addEventListener('click', function(e) {
    var t = e.target.closest('[aria-controls="mini-cart"], [data-open-cart]');
    if (!t) return;
    e.preventDefault();
    refreshAndOpen();
  }, true);

  var _lastKnownCount = 0;
  var _addInProgress = false;

  // --- v23 — cadeau orphelin ---
  // Toutes les écritures du tiroir passent par une file : une requête à la fois,
  // chaque étape lit le panier renvoyé par la précédente (jamais un état périmé).
  function parseIds(s) {
    return String(s || '').split(',').map(function(x) { return parseInt(x, 10); }).filter(function(n) { return n > 0; });
  }
  var GIFT_REQUIRED = parseIds(drawer.dataset.giftRequired);
  var GIFT_PRODUCTS = parseIds(drawer.dataset.giftProducts);
  var GIFT_GUARD_ON = GIFT_REQUIRED.length > 0 && GIFT_PRODUCTS.length > 0;
  var IS_CART_PAGE = /\/cart\/?$/.test(location.pathname);
  var _cartQueue = Promise.resolve();
  var _pending = 0;
  var _giftRemovals = [];

  function enqueue(task) {
    _pending++;
    var run = _cartQueue.then(task);
    _cartQueue = run.catch(function() {});
    return run.then(
      function(v) { _pending--; return v; },
      function(err) { _pending--; throw err; }
    );
  }

  function fetchCart() {
    return fetch(BASE + '/cart.js', { cache: 'no-store' }).then(function(r) {
      if (!r.ok) throw new Error('cart');
      return r.json();
    });
  }

  function isGiftLine(item) {
    if (GIFT_PRODUCTS.indexOf(item.product_id) === -1) return false;
    var props = item.properties || {};
    return item.final_price === 0 || (props._Gifted != null && props._Gifted !== '');
  }

  function orphanGiftKeys(cart) {
    if (!GIFT_GUARD_ON || !cart || !cart.items) return [];
    var hasMain = cart.items.some(function(i) {
      return i.quantity > 0 && GIFT_REQUIRED.indexOf(i.product_id) !== -1 && !isGiftLine(i);
    });
    if (hasMain) return [];
    return cart.items.filter(isGiftLine).map(function(i) { return i.key; });
  }

  // À appeler DANS la file. Résout { cart, removed } avec le panier final.
  function enforceGift(cart) {
    var keys = orphanGiftKeys(cart);
    if (!keys.length) return Promise.resolve({ cart: cart, removed: false });
    // Anti ping-pong si une app ré-ajoute le cadeau aussitôt : 3 retraits max / 10 s.
    var now = Date.now();
    _giftRemovals = _giftRemovals.filter(function(t) { return now - t < 10000; });
    if (_giftRemovals.length >= 3) return Promise.resolve({ cart: cart, removed: false });
    _giftRemovals.push(now);
    var updates = {};
    keys.forEach(function(k) { updates[k] = 0; });
    return fetch(BASE + '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
    .then(function(r) { if (!r.ok) throw new Error('update'); return r.json(); })
    .then(function(c) { return { cart: c, removed: true }; });
  }

  // Page panier : le contenu principal est rendu par le thème → rechargement
  // (borné à 2 / 30 s pour ne jamais boucler).
  function reloadCartPage() {
    var now = Date.now(), log = [];
    try { log = JSON.parse(sessionStorage.getItem('cd_gift_reloads') || '[]'); } catch (e) {}
    log = log.filter(function(t) { return now - t < 30000; });
    if (log.length >= 2) return false;
    log.push(now);
    try { sessionStorage.setItem('cd_gift_reloads', JSON.stringify(log)); } catch (e) {}
    location.reload();
    return true;
  }

  function afterGiftRemoved(cart) {
    _lastKnownCount = cart.item_count;
    if (IS_CART_PAGE && reloadCartPage()) return;
    try {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
    } catch (e) {}
    if (_pending === 0) refreshDrawer();
  }

  var _giftTimer = null;
  function scheduleGiftCheck(delay) {
    if (!GIFT_GUARD_ON) return;
    clearTimeout(_giftTimer);
    _giftTimer = setTimeout(function() {
      enqueue(function() { return fetchCart().then(enforceGift); })
        .then(function(res) { if (res.removed) afterGiftRemoved(res.cart); })
        .catch(function() {});
    }, delay || 0);
  }

  // Changement de quantité / suppression depuis le tiroir, ligne ciblée par sa clé.
  function changeLine(key, qty) {
    return enqueue(function() {
      return fetch(BASE + '/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
      .then(function(r) { if (!r.ok) throw new Error('change'); return r.json(); })
      .then(enforceGift);
    })
    .then(function(res) {
      _lastKnownCount = res.cart.item_count;
      if (res.removed && IS_CART_PAGE && reloadCartPage()) return;
      if (_pending === 0) refreshDrawer();
    })
    .catch(function() { if (_pending === 0) refreshDrawer(); });
  }

  // Chargement : Liquid a déjà détecté un cadeau orphelin → retrait immédiat.
  if (drawer.hasAttribute('data-gift-orphan')) scheduleGiftCheck(0);
  // Retour arrière (page restaurée depuis le cache du navigateur) : état à revérifier.
  window.addEventListener('pageshow', function(e) { if (e.persisted) scheduleGiftCheck(0); });
  // Événements panier éventuels du thème ou d'apps.
  ['cart:updated', 'cart:change'].forEach(function(evt) {
    document.addEventListener(evt, function() { scheduleGiftCheck(150); });
  });

  // Avant « Commander » : dernier contrôle (sans bloquer la vente si le réseau échoue).
  drawer.addEventListener('submit', function(e) {
    var form = e.target;
    if (!GIFT_GUARD_ON || !form || form.id !== 'cd-form') return;
    e.preventDefault();
    enqueue(function() { return fetchCart().then(enforceGift); })
      .then(function(res) {
        if (res.removed) {
          _lastKnownCount = res.cart.item_count;
          if (!res.cart.item_count) { refreshDrawer(); return; }
        }
        form.submit();
      })
      .catch(function() { form.submit(); });
  }, true);

  function onProductAdded() {
    if (_addInProgress) return;
    _addInProgress = true;
    setTimeout(function() {
      refreshDrawer(function() {
        open();
        _addInProgress = false;
      });
    }, 120);
  }

  var cartCountEls = document.querySelectorAll('cart-count, [data-cart-count]');
  if (cartCountEls.length > 0 && window.MutationObserver) {
    var cartCountObserver = new MutationObserver(function() {
      if (_addInProgress) return;
      fetch(BASE + '/cart.js', { cache: 'no-store' })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          if (cart.item_count > _lastKnownCount) {
            _lastKnownCount = cart.item_count;
            onProductAdded();
          } else {
            _lastKnownCount = cart.item_count;
          }
          if (orphanGiftKeys(cart).length) scheduleGiftCheck(0);
        })
        .catch(function() {});
    });
    cartCountEls.forEach(function(el) {
      cartCountObserver.observe(el, { childList: true, characterData: true, subtree: true });
    });
  }

  function refreshAndOpen() {
    if (refreshLock) return;
    refreshLock = true;
    refreshDrawer(function() {
      refreshLock = false;
      open();
    });
  }

  function hideFocalNotif() {
    var n = document.querySelector('cart-notification');
    if (n) { n.setAttribute('hidden', ''); n.style.cssText = 'display:none!important'; }
  }
  hideFocalNotif();
  new MutationObserver(hideFocalNotif).observe(document.body, { childList: true, subtree: false });

  function applySuggestDismissed() {
    try {
      if (sessionStorage.getItem('cd_suggest_dismissed') === '1') {
        var s = drawer.querySelector('[data-cd-suggest]');
        if (s) s.style.display = 'none';
      }
    } catch (e) {}
  }
  applySuggestDismissed();

  // --- v15.3 — pastilles couleur sur les puces de variantes upsell ---
  // Si TOUTES les variantes d'une carte portent un nom de couleur reconnu,
  // les puces texte deviennent des pastilles rondes (comme le bloc
  // « Complétez votre routine ») + nom de la variante sélectionnée en italique.
  // Sinon (tailles, formats, couleur inconnue…) : puces texte inchangées.
  var CD_SWATCHES = [
    [/argent|silver|chrome|chrom\b|acier|inox|steel|plata|metal/, 'linear-gradient(135deg,#f5f5f5 0%,#b9bcc2 55%,#8e9096 100%)'],
    [/\bor\b|dore|gold|\boro\b|dorado|laiton|brass/, 'linear-gradient(135deg,#f3e3b2 0%,#d4af37 60%,#a8842c 100%)'],
    [/noir|black|nero|schwarz|negro/, '#16161a'],
    [/blanc|white|bianco|weiss|blanco/, '#f4f4f2'],
    [/marron|brun\b|brune\b|brown|marrone|braun|cognac|camel|caramel|chocolat|moka|\btan\b|cuir|leather/, '#8b5a2b'],
    [/bleu|blue|\bblu\b|azzurro|azul|navy|marine|petrole|turquoise|cyan/, '#2f4e7a'],
    [/vert|green|verde|grun|olive|kaki|khaki|sauge|menthe|mint/, '#3f6b4f'],
    [/rouge|\bred\b|rosso|\brot\b|rojo|bordeaux|burgundy|grenat|cerise/, '#a02c2c'],
    [/rose\b|pink|rosa|fuchsia|magenta/, '#e0a3b6'],
    [/violet|purple|lilas|mauve|viola|lavande|lavender|prune|plum/, '#7c5aa0'],
    [/jaune|yellow|giallo|gelb|amarillo|moutarde|mustard/, '#e3bf47'],
    [/orange|arancio|naranja|corail|coral|abricot|peche|terracotta/, '#d97a3a'],
    [/beige|sable|sand\b|creme|cream|ivoire|ivory|ecru|nude|champagne|taupe/, '#d6c4a4'],
    [/gris|grey|gray|grigio|grau|anthracite|graphite|ardoise|slate/, '#8a8d92']
  ];

  function cdNormalizeLabel(s) {
    return ' ' + String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, ' ').trim() + ' ';
  }
  function cdSwatchFor(label) {
    var t = cdNormalizeLabel(label);
    for (var i = 0; i < CD_SWATCHES.length; i++) {
      if (CD_SWATCHES[i][0].test(t)) return CD_SWATCHES[i][1];
    }
    return null;
  }
  function applyVariantSwatches() {
    drawer.querySelectorAll('[data-cd-suggest-card] .cd-suggest__variants').forEach(function(wrap) {
      if (wrap.dataset.cdSwatched) return;
      wrap.dataset.cdSwatched = '1';
      var chips = Array.prototype.slice.call(wrap.querySelectorAll('[data-cd-variant]'));
      if (!chips.length) return;
      var colors = chips.map(function(c) { return cdSwatchFor(c.textContent); });
      for (var i = 0; i < colors.length; i++) {
        if (!colors[i]) return; // une variante non-couleur → on garde les puces texte
      }
      chips.forEach(function(c, i) {
        var label = c.textContent.trim();
        c.classList.add('cd-suggest__variant--dot');
        c.style.setProperty('--swatch', colors[i]);
        c.setAttribute('aria-label', label);
        c.setAttribute('title', label);
      });
      var name = document.createElement('span');
      name.className = 'cd-suggest__variant-name';
      var sel = wrap.querySelector('[data-cd-variant].is-selected') || chips[0];
      name.textContent = sel.getAttribute('aria-label') || sel.textContent.trim();
      wrap.appendChild(name);
    });
  }
  applyVariantSwatches();

  drawer.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-cd-suggest-close]');
    if (!btn) return;
    e.preventDefault();
    var s = drawer.querySelector('[data-cd-suggest]');
    if (s) s.style.display = 'none';
    try { sessionStorage.setItem('cd_suggest_dismissed', '1'); } catch(e2) {}
  });

  drawer.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-cd-qty]');
    if (!btn) return;
    e.preventDefault();
    var line = parseInt(btn.dataset.line, 10);
    var input = btn.parentElement.querySelector('.cd-qty__val');
    var oldVal = parseInt(input.value, 10) || 1;
    var newVal = btn.dataset.cdQty === 'plus' ? oldVal + 1 : Math.max(0, oldVal - 1);
    input.value = newVal;
    changeLine(btn.dataset.key, newVal);
  });

  drawer.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-cd-remove]');
    if (!btn) return;
    e.preventDefault();
    var line = parseInt(btn.dataset.cdRemove, 10);
    var item = btn.closest('.cd-item');
    if (item) item.style.opacity = '0.4';
    changeLine(btn.dataset.key, 0);
  });

  // --- v15.2 — sélection de variante sur les cartes upsell ---
  // Clic sur une puce (texte ou pastille) : sélection visuelle, mise à jour du
  // prix / prix barré / image / nom de variante, et l'ID variante du bouton
  // Ajouter est remplacé. Délégué sur le drawer : survit aux re-rendus.
  drawer.addEventListener('click', function(e) {
    var chip = e.target.closest('[data-cd-variant]');
    if (!chip || chip.disabled) return;
    e.preventDefault();
    var card = chip.closest('[data-cd-suggest-card]');
    if (!card) return;

    card.querySelectorAll('[data-cd-variant]').forEach(function(c) {
      c.classList.toggle('is-selected', c === chip);
    });

    var nameEl = card.querySelector('.cd-suggest__variant-name');
    if (nameEl) nameEl.textContent = (chip.getAttribute('aria-label') || chip.textContent).trim();

    var priceEl = card.querySelector('.cd-suggest__price');
    if (priceEl && chip.dataset.price) priceEl.textContent = chip.dataset.price;

    var pricing = card.querySelector('.cd-suggest__pricing');
    var compareEl = card.querySelector('.cd-suggest__compare');
    if (chip.dataset.compare) {
      if (!compareEl && pricing) {
        compareEl = document.createElement('span');
        compareEl.className = 'cd-suggest__compare';
        pricing.insertBefore(compareEl, pricing.firstChild);
      }
      if (compareEl) compareEl.textContent = chip.dataset.compare;
    } else if (compareEl && compareEl.parentNode) {
      compareEl.parentNode.removeChild(compareEl);
    }

    var img = card.querySelector('.cd-suggest__img');
    if (img && chip.dataset.image) img.src = chip.dataset.image;

    var addBtn = card.querySelector('[data-cd-upsell-add]');
    if (addBtn) addBtn.dataset.cdUpsellAdd = chip.dataset.cdVariant;
  });

  drawer.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-cd-upsell-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var vid = btn.dataset.cdUpsellAdd;
    btn.classList.add('is-loading');
    btn.disabled = true;
    fetch(BASE + '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1 }] })
    })
    .then(function(r) { if (!r.ok) throw new Error(); return r.json(); })
    .then(function() {
      btn.classList.remove('is-loading');
      btn.classList.add('is-done');
      btn.innerHTML = '<svg viewBox="0 0 24 24" width="11" height="11" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
      setTimeout(function() {
        refreshDrawer(function() {
          fetch(BASE + '/cart.js').then(function(r) { return r.json(); }).then(function(c) { _lastKnownCount = c.item_count; });
        });
      }, 380);
    })
    .catch(function() {
      btn.classList.remove('is-loading');
      btn.disabled = false;
    });
  });

  var _refreshSeq = 0;
  function refreshDrawer(callback) {
    var seq = ++_refreshSeq;
    var sid = drawer.closest('.shopify-section')
      ? drawer.closest('.shopify-section').id.replace('shopify-section-', '')
      : 'cart-drawer';
    fetch(BASE + '/?sections=' + sid)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var html = data[sid];
        // v23 — une réponse plus ancienne qu'un re-rendu suivant ne l'écrase pas
        if (!html || seq !== _refreshSeq) { if (callback) callback(); return; }
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var nd = tmp.querySelector('#mini-cart');
        if (nd) {
          var p = drawer.querySelector('.cd__panel');
          var np = nd.querySelector('.cd__panel');
          if (p && np) p.innerHTML = np.innerHTML;
        }
        applySuggestDismissed();
        applyVariantSwatches();
        fetch(BASE + '/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
          document.querySelectorAll('cart-count, [data-cart-count]').forEach(function(el) {
            el.textContent = cart.item_count;
          });
          if (callback) callback();
        });
      })
      .catch(function() { if (callback) callback(); });
  }

  /* ===== Le Lamier (vitrine Tinker): ligações com o tema ===== */
  // o clique de abrir também não pode chegar ao drawer nativo do Tinker
  document.addEventListener('click', function(e) {
    if (e.target.closest('[aria-controls="mini-cart"], [data-open-cart]')) e.stopPropagation();
  }, true);
  function marcaBotoes() {
    document.querySelectorAll('header-component [href="/cart"], header-component .header-actions__cart-icon, header-component [aria-label*="anier"], header-component cart-icon, header-component .cart-bubble').forEach(function(el) {
      var b = el.closest('a,button') || el; b.setAttribute('data-open-cart', '');
    });
  }
  marcaBotoes(); document.addEventListener('DOMContentLoaded', marcaBotoes);
  // drawer nativo do Tinker desligado: o bundle chama openLLCartDrawer após o add
  window.openLLCartDrawer = function() { afterAdd(); };
  function mataNativo() {
    var td = document.querySelector('theme-drawer#cart-drawer') || (document.querySelector('cart-drawer-component') || {}).closest && document.querySelector('cart-drawer-component').closest('theme-drawer');
    if (td && !td.__llOff) { td.__llOff = true; td.open = function() { afterAdd(); }; td.showModal = td.open; }
  }
  mataNativo(); document.addEventListener('DOMContentLoaded', mataNativo);
  // o dialog nativo do Tinker abre sozinho após o add (evento do próprio tema) e,
  // mesmo invisível, trava a rolagem e deixa uma faixa branca: fecha e remove
  function removeNativo() {
    var sec = document.getElementById('shopify-section-cart-drawer-section');
    if (!sec) return;
    sec.querySelectorAll('dialog').forEach(function (dl) { try { if (dl.open) dl.close(); } catch (e) {} });
    sec.remove();
    document.documentElement.classList.remove('scroll-lock'); document.body.classList.remove('scroll-lock');
  }
  removeNativo(); document.addEventListener('DOMContentLoaded', removeNativo);
  new MutationObserver(function () {
    var dl = document.querySelector('#shopify-section-cart-drawer-section dialog[open]');
    if (dl) removeNativo();
  }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['open'], childList: true });

  // brinde: rasoir no carrinho -> "Socle Lamier OFFERT" da mesma cor (a referência faz isso por app)
  function ensureGift(cart) {
    if (!GIFT_GUARD_ON || !cart || !cart.items) return Promise.resolve(cart);
    var main = cart.items.filter(function(i) { return GIFT_REQUIRED.indexOf(i.product_id) !== -1 && !isGiftLine(i); });
    var gifts = cart.items.filter(isGiftLine);
    if (!main.length || gifts.length) return Promise.resolve(cart);
    return fetch(BASE + '/products/' + (window.LL_GIFT_HANDLE || 'socle-lamier-copie') + '.js').then(function(r) { return r.json(); }).then(function(p) {
      var cor = (main[0].variant_title || '').toLowerCase();
      var v = p.variants.filter(function(x) { return (x.title || '').toLowerCase() === cor; })[0] || p.variants[0];
      return fetch(BASE + '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }), __llInterno: true })
        .then(fetchCart);
    }).catch(function() { return cart; });
  }
  // abre a gaveta assim que o add responde (antes esperava brinde + re-render, 1 a 2 s sem resposta visual);
  // o conteúdo fica esmaecido até o re-render chegar
  function afterAdd() {
    open();
    drawer.classList.add('ll-carregando');
    var pronto = function() { drawer.classList.remove('ll-carregando'); };
    enqueue(function() { return fetchCart().then(ensureGift); })
      .then(function(c) { _lastKnownCount = c.item_count; document.querySelectorAll('cart-count, [data-cart-count], header-component .cart-bubble__text-count').forEach(function(el) { el.textContent = c.item_count; }); refreshDrawer(pronto); })
      .catch(function() { refreshDrawer(pronto); });
  }
  (function() {
    var css = document.createElement('style');
    css.textContent = '#mini-cart.ll-carregando .cd__panel{opacity:.55;pointer-events:none;transition:opacity .15s}';
    document.head.appendChild(css);
  })();
  // qualquer add ao carrinho (PDP, rotina, upsell do drawer) passa por aqui
  var _f = window.fetch;
  window.fetch = function(input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var pr = _f.apply(this, arguments);
    if (/\/cart\/add(\.js)?(\?|$)/.test(url) && !(init && init.__llInterno)) {
      pr.then(function(r) { if (r.ok && !_addInProgress) setTimeout(afterAdd, 60); }).catch(function() {});
    }
    return pr;
  };
})();